import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getAuth } from 'firebase/auth'
import firebaseConfig from './firebaseConfig'

const firebaseApp = initializeApp(firebaseConfig)

export const db = getFirestore(firebaseApp)

export const auth = getAuth(firebaseApp)